import React from 'react'
import { Box, Icon, IconButton, makeStyles, Typography } from '@material-ui/core'

const ContactDetails = () => {
  
  const useStyles = makeStyles((theme) => ({
    info: {
      color: theme.palette.grey[600]
    }
  }))

  const classes = useStyles()

  const details = [
    {
      icon: 'location_on',
      info: '312 P. Zamora St. Caloocan City, Philippines'
    },
    {
      icon: 'call',
      info: '555 - 555 - 5555'
    },
    {
      icon: 'email',
      info: 'jeeasistio08@gmail.com'
    }
  ]

  return (
    <React.Fragment>
      <Typography variant="h5" align="center">
        Talk to Us
      </Typography>
      {details.map(({ icon, info }) => (
        <Box
          display="flex"
          flexDirection={['column', 'row']}
          justifyContent="space-between"
          alignItems="center"
          mx={2}
          my={4}
          textAlign={['center', 'right']}
        >
          <Icon color="primary">{icon}</Icon>
          <Typography className={classes.info}>{info}</Typography>
        </Box>
      ))}
      <hr />
      <Box textAlign="center">
        {['facebook', 'codepen', 'twitter', 'github'].map((brand) => (
          <IconButton
            key={brand}
            component="a"
            href={`https://${brand}.com/jeeasistio`}
            target="_blank"
          >
            <Icon fontSize="1rem" className={`fab fa-${brand}`} />
          </IconButton>
        ))}
      </Box>
    </React.Fragment>
  )
}

export default ContactDetails
